import { parse } from '@plussub/srt-vtt-parser';

const MS_PER_SECOND = 1000;

export type ParsedVttCue = {
  endTimeSeconds: number;
  startTimeSeconds: number;
  text: string;
};

export const parseWebVtt = (vttText: string): ParsedVttCue[] =>
  parse(vttText).entries.map(({ from, to, text }) => ({
    endTimeSeconds: to / MS_PER_SECOND,
    startTimeSeconds: from / MS_PER_SECOND,
    text,
  }));
